/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";

/**
 * Direction the movement takes, read with the description of what it moves.
 *
 * The folios that also carry the reason they were registered with name this row
 * after the movement itself, so the title travels with it.
 *
 * @param {Function} t - Translation handler.
 * @param {Object} movementType - Direction of the movement.
 * @param {string} title - Title the row is read with.
 */
const MovementTypeSection = ({t, movementType, title = 'movement_type'}) => {
    const Icon = movementType?.Icon;

    return (
        <>
            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>{t(title)}</p>
            <div className='col-12 px-0'>
                <div className='d-flex flex-grow-1 minw-0 justify-content-start p-0'>
                    <div className={"mr-2 d-flex align-items-center"}>
                        {Icon && <Icon/>}
                    </div>
                    <p className={"fs-14px"}>{t(movementType?.trans)} — {t(movementType?.description)}</p>
                </div>
            </div>
        </>
    );
};

export default MovementTypeSection;
